__turbopack_context__.v({
  "activePage": "styles-module__tNfGHW__activePage",
  "compact": "styles-module__tNfGHW__compact",
  "disabled": "styles-module__tNfGHW__disabled",
  "paginationButton": "styles-module__tNfGHW__paginationButton",
  "paginationContainer": "styles-module__tNfGHW__paginationContainer",
  "paginationEllipsis": "styles-module__tNfGHW__paginationEllipsis",
  "paginationInfo": "styles-module__tNfGHW__paginationInfo",
  "paginationPageButton": "styles-module__tNfGHW__paginationPageButton",
});
